export enum SecretTypeEnum {
  NORMAL = 'normal',
  CURRENT = 'current',
  NEW = 'new',
  CONFIRMATION = 'confirmation'
}

export namespace SecretTypeEnum {
  export const valueOf = (passwordType?: string): SecretTypeEnum | undefined => {
    const keys = Object.keys(SecretTypeEnum)
    const toTest = passwordType?.toUpperCase() ?? 'undefined'
    const isPresent = keys.includes(toTest.toUpperCase())
    return passwordType != null && isPresent
      ? SecretTypeEnum[passwordType.toUpperCase()]
      : undefined
  }
}